// extracted by mini-css-extract-plugin
export default {"container":"DashboardCard_container__ZRscY","details_container":"DashboardCard_details_container__Cu7uE","title":"DashboardCard_title__PqJez","value":"DashboardCard_value__t7Q0H"};